import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { WatershedSFA } from './App';
import Site from './siteview/Site';

let prefix = "/";
if (process.env.REACT_APP_PREFIX) {
    prefix = process.env.REACT_APP_PREFIX;
}

ReactDOM.render(
    (
    <Router basename={prefix}>
        <div>
            <Switch>
                <Route exact path="/" component={WatershedSFA} />
                <Route path={"/sites/:id"} component={Site} />
            </Switch>
        </div>
    </Router>),
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js